import React from "react";
import ImageSection from "../../components/common/ImageSection";
import { Ring_circle } from "../../helper/imageConstant";
import { NavLink } from "react-router-dom";

const PrivacyPolicy = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <>
      <ImageSection name={"Privacy Policy "} />
      <section className="relative p-4 my-5 lg:my-5 xl:pb-14 overflow-hidden fonts text-justify">
        <div className="lg:mx-20 xl:mx-24 2xl:mx-32 3xl:mx-40 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="grid grid-cols-1 gap-10">
            <p className="text-base lg:text-base 3xl:text-lg font-normal">
              We value the trust you place in us. That's why we insist upon the
              highest standards for secure transactions and customer information
              privacy. Please read the following statement to learn about our
              information gathering and dissemination practices.
            </p>
            <div className="p-4 lg:p-8 text-[#A5302E] text-base lg:text-base 3xl:text-lg leading-normal font-medium border border-[#A5302E] flex flex-col gap-3">
              <h1>Note:</h1>
              <p className="break-words space-y-3">
                Our privacy policy is subject to change at any time without
                notice. To make sure you are aware of any changes, please review
                this policy periodically.
              </p>
              <p>
                By visiting this Website you agree to be bound by the terms and
                conditions of this Privacy Policy. If you do not agree please do
                not use or access our Website.
              </p>
              <p>
                By mere use of the Website, you expressly consent to our use and
                disclosure of your personal information in accordance with this
                Privacy Policy. This Privacy Policy is incorporated into and
                subject to the Terms of Use.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                1. Collection of Personally Identifiable Information and other
                Information
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  When you use our Website, we collect and store your personal
                  information which is provided by you from time to time. Our
                  primary goal in doing so is to provide you a safe, efficient,
                  smooth and customized experience.
                </li>
                <li>
                  In general, you can browse the Website without telling us who
                  you are or revealing any personal information about yourself.
                  Once you give us your personal information, you are not
                  anonymous to us. Where possible, we indicate which fields are
                  required and which fields are optional. You always have the
                  option to not provide information by choosing not to use a
                  particular service or feature on the Website.
                </li>
                <li>
                  We may automatically track certain information about you based
                  upon your behaviour on our Website. We use this information to
                  do internal research on our users' demographics, interests,
                  and behaviour to better understand, protect and serve our
                  users. This information is compiled and analysed on an
                  aggregated basis. This information may include the URL that
                  you just came from (whether this URL is on our Website or
                  not), which URL you next go to (whether this URL is on our
                  Website or not), your computer browser information, and your
                  IP address.
                </li>
                <li>
                  We use data collection devices such as "cookies" on certain
                  pages of the Website to help analyse our web page flow,
                  measure promotional effectiveness, and promote trust and
                  safety. "Cookies" are small files placed on your hard drive
                  that assist us in providing our services. We offer certain
                  features that are only available through the use of a
                  "cookie".
                </li>
                <li>
                  We also use cookies to allow you to enter your password less
                  frequently during a session. Cookies can also help us provide
                  information that is targeted to your interests. Most cookies
                  are "session cookies," meaning that they are automatically
                  deleted from your hard drive at the end of a session. You are
                  always free to decline our cookies if your browser permits,
                  although in that case you may not be able to use certain
                  features on the Website and you may be required to re-enter
                  your password more frequently during a session.
                </li>
                <li>
                  If you choose to buy on the Website, we collect information
                  about your buying behaviour.
                </li>
                <li>
                  if you transact with us, we collect some additional
                  information, such as a billing address, a credit / debit card
                  number and a credit / debit card expiration date and/ or other
                  payment instrument details and tracking information from
                  cheques or money orders.
                </li>
                <li>
                  If you choose to post messages on our message boards, chat
                  rooms or other message areas or leave feedback, we will
                  collect that information you provide to us. We retain this
                  information as necessary to resolve disputes, provide customer
                  support and troubleshoot problems as permitted by law.
                </li>
                <li>
                  If you send us personal correspondence, such as emails or
                  letters, or if other users or third parties send us
                  correspondence about your activities or postings on the
                  Website, we may collect such information into a file specific
                  to you.
                </li>
                <li>
                  We collect personally identifiable information (email address,
                  name, phone number, credit card / debit card / other payment
                  instrument details, etc.) from you when you set up a free
                  account with us. While you can browse some sections of our
                  Website without being a registered member, certain activities
                  (such as placing an order) do require registration. We do use
                  your contact information to send you offers based on your
                  previous orders and your interests.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                2. Use of Demographic / Profile Data / Your Information
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  We use personal information to provide the services you
                  request. To the extent we use your personal information to
                  market to you, we will provide you the ability to opt-out of
                  such uses. We use your personal information to resolve
                  disputes; troubleshoot problems; help promote a safe service;
                  collect money; measure consumer interest in our products and
                  services, inform you about online and offline offers,
                  products, services, and updates; customize your experience;
                  detect and protect us against error, fraud and other criminal
                  activity; enforce our terms and conditions; and as otherwise
                  described to you at the time of collection.
                </li>
                <li>
                  In our efforts to continually improve our product and service
                  offerings, we collect and analyse demographic and profile data
                  about our users' activity on our Website.
                </li>
                <li>
                  We identify and use your IP address to help diagnose problems
                  with our server, and to administer our Website. Your IP
                  address is also used to help identify you and to gather broad
                  demographic information.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                3. Sharing of personal information
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  We use other third parties such as a shipping company to
                  fulfil orders, and a payment gateway company to bill you for
                  goods and services, and an email service provider to send out
                  emails on our behalf. When you sign up for our services, we
                  will share your personal information as necessary for the
                  third party to provide that service.
                </li>
                <li>
                  We may share personal information with our other corporate
                  entities and affiliates to help detect and prevent identity
                  theft, fraud and other potentially illegal acts; correlate
                  related or multiple accounts to prevent abuse of our services;
                  and to facilitate joint or co-branded services that you
                  request where such services are provided by more than one
                  corporate entity. Those entities and affiliates may not market
                  to you as a result of such sharing unless you explicitly
                  opt-in.
                </li>
                <li>
                  We may disclose personal information if required to do so by
                  law or in the good faith belief that such disclosure is
                  reasonably necessary to respond to subpoenas, court orders, or
                  other legal process. We may disclose personal information to
                  law enforcement offices, third party rights owners, or others
                  in the good faith belief that such disclosure is reasonably
                  necessary to: enforce our Terms or Privacy Policy; respond to
                  claims that an advertisement, posting or other content
                  violates the rights of a third party; or protect the rights,
                  property or personal safety of our users or the general
                  public.
                </li>
                <li>
                  We and our affiliates will share / sell some or all of your
                  personal information with another business entity should we
                  (or our assets) plan to merge with, or be acquired by that
                  business entity, or re-organization, amalgamation,
                  restructuring of business. Should such a transaction occur
                  that other business entity (or the new combined entity) will
                  be required to follow this privacy policy with respect to your
                  personal information.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium ">
                5. Security Precautions{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  The security of your personal information is important to us.
                  We follow generally accepted industry standards to protect the
                  personal information submitted to us, both during transmission
                  and once we receive it. No method of transmission over the
                  Internet, or method of electronic storage, is 100% secure,
                  however. Therefore, we cannot guarantee its absolute security.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                6. Newsletters / Service-related Announcements{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  If you wish to subscribe to our newsletter(s), we will use
                  your name and email address to send the newsletter to you. You
                  may unsubscribe from these communications at any time by
                  following the instruction contained within each of the
                  communications you receive.
                </li>
                <li>
                  We will send you strictly service-related announcements on
                  rare occasions when it is necessary to do so. For instance, if
                  our service is temporarily suspended for maintenance, we might
                  send you an email. Generally, you may not opt-out of these
                  communications, which are not promotional in nature. If you do
                  not wish to receive them, you have the option to deactivate
                  your account.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                7. Public Forums{" "}
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Our Web site offers publicly accessible blogs or community
                  forums. You should be aware that any information you provide
                  in these areas may be read, collected, and used by others who
                  access them. To request removal of your personal information
                  from our blog or community forum, contact us at
                  info@vikasfashion.com in some cases, we may not be able to
                  remove your personal information, in which case we will let
                  you know if we are unable to do so and why.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                8. Your Consent
              </h1>
              <ul className="list-disc pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  By using the Website and/ or by providing your information,
                  you consent to the collection and use of the information you
                  disclose on the Website in accordance with this Privacy
                  Policy, including but not limited to Your consent for sharing
                  your information as per this privacy policy.
                </li>
                <li>
                  If we decide to change our privacy policy, we will post those
                  changes on this page so that you are always aware of what
                  information we collect, how we use it, and under what
                  circumstances we disclose it.
                </li>
              </ul>
            </div>
            <div className="space-y-6">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Contact Us
              </h1>
              <ul className="list-none text-base lg:text-base 3xl:text-lg font-medium space-y-4">
                <li>
                  If you have any questions/comments about privacy policy, you
                  should contact us on {""}
                  <span className="text-[#A5302E]">info@vikasfashion.com </span>
                  or for postal address{" "}
                  <NavLink
                    to={"/contact-us"}
                    onClick={scrollToTop}
                    className="text-[#A5302E] underline"
                  >
                    click here
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="hidden lg:block absolute lg:bottom-[50%] lg:-right-[8%] xl:-right-[8%] 2xl:-right-[9%] 3xl:bottom-[50%] 3xl:-right-[8%]">
          <div className="lg:w-36 xl:w-44 2xl:w-60 3xl:w-64 h-full">
            <img src={Ring_circle} alt="" className="object-cover" />
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
